import ShoppingBagsIcon from './ShoppingBagsIcon'

export default ShoppingBagsIcon
